/**
 * Created by Ivan on 02.11.2026
 */

const Merge2MissionHelper = {
    getPeriod: function () {
        const lastRemoved = cleverapps.missionManager.getLastRemoved(Mission.TYPE_MERGE2_MISSION);
        const event = cleverapps.eventManager.listFeatureEvents("merge2mission")
            .filter((event) => cleverapps.eventManager.isEventApplicable(event) && event.finish.getTime() > lastRemoved)
            .sort((a, b) => a.start.getTime() - b.start.getTime())[0];
        return event && event.options.period;
    },

    getEvent: function (period) {
        return cleverapps.eventManager.listFeatureEvents("merge2mission").find((event) => event.options.period === period);
    },

    getCurrentPeriod: function () {
        const mission = cleverapps.missionManager.findByType(Mission.TYPE_MERGE2_MISSION);
        return mission && mission.logic ? mission.logic.period : Merge2MissionHelper.getPeriod();
    },

    getString: function (period, prefix, suffix) {
        return `${prefix}${period.charAt(0).toUpperCase()}${period.slice(1)}${suffix || ""}`;
    },

    getBundleName: function (period) {
        return `merge2mission_${period}`;
    },

    getBundle: function (period) {
        return bundles[Merge2MissionHelper.getBundleName(period || Merge2MissionHelper.getCurrentPeriod())];
    },

    hasBundles: function (period) {
        return Boolean(period && bundles[Merge2MissionHelper.getBundleName(period)]);
    }
};
